'use client'

import React, { FC, ReactElement } from 'react'
import CollectionComponent from '@/app/collection/[id]/collection-component'
import useWindowSize from '@/utils/hooks/useWindowSize'
import { collectionObjectRouteSlug } from '@/utils/collection-object'
import type { CollectionObjectType } from '@/utils/collection-object'
import CollectionObjectProvenance from './provenance-panel'

const GalleryCollectionView: FC<{
	inscription: any
	objectType: Exclude<CollectionObjectType, 'collection'>
	metaData: any
	collectionStats: any
	isMobile: boolean
}> = ({ inscription, objectType, metaData, collectionStats, isMobile: _isMobileProp }): ReactElement => {
	const { isMobile } = useWindowSize()
	const objectSlug = collectionObjectRouteSlug(objectType, inscription.id)
	const title = metaData?.name || (objectType === 'gallery' ? 'On-chain Gallery' : 'Parent Collection')
	const headerActions = (
		<CollectionObjectProvenance
			inscription={inscription}
			objectType={objectType}
			metaData={metaData}
		/>
	)

	return (
		<div className="-ml-4" style={{ width: 'calc(100vw + 32px)' }}>
			<CollectionComponent
				metaData={metaData}
				collectionStats={collectionStats}
				collection_slug={objectSlug}
				isRemote={true}
				title={title}
				inscriptions={[]}
				isMobile={isMobile}
				headerActions={headerActions}
			/>
		</div>
	)
}

export default GalleryCollectionView
